import axios from "axios";

// Create Axios instance with baseURL from environment
const API = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
});

// Function to fetch recent donations
export const fetchDonations = () => API.get("/donations/recent");

